// ---------------------------------------------------------------------------
// โมเดลธุรกิจที่ระบบรองรับ (ระบบกลาง 1 ตัว ใช้ได้หลายอุตสาหกรรม)
// เลือกโมเดล -> ระบบ preset ว่าเปิด feature module ตัวไหนบ้าง
// องค์กรยังปรับเปิด-ปิดเองได้ทีหลังที่หน้า Module Manager
// ---------------------------------------------------------------------------

export const BUSINESS_MODELS = [
  {
    key: "clinic",
    name: "คลินิกความงาม / เวชกรรม",
    nameEn: "Aesthetic Clinic",
    icon: "stethoscope",
    resourceLabel: "ห้องทรีตเมนต์",
    staffLabel: "แพทย์ / ผู้ช่วย",
    modules: ["crm", "booking", "resource", "catalog", "course", "billing", "installment", "membership", "chat", "slip", "campaign", "inventory", "contract"],
  },
  {
    key: "dental",
    name: "คลินิกทันตกรรม",
    nameEn: "Dental Clinic",
    icon: "medkit",
    resourceLabel: "ยูนิตทำฟัน",
    staffLabel: "ทันตแพทย์",
    modules: ["crm", "booking", "resource", "catalog", "course", "billing", "installment", "membership", "chat", "inventory"],
  },
  {
    key: "vet",
    name: "โรงพยาบาลสัตว์",
    nameEn: "Veterinary",
    icon: "paw",
    resourceLabel: "ห้องตรวจ",
    staffLabel: "สัตวแพทย์",
    modules: ["crm", "booking", "resource", "catalog", "billing", "inventory", "chat", "membership"],
  },
  {
    key: "fitness",
    name: "ฟิตเนส / สตูดิโอ",
    nameEn: "Fitness & Studio",
    icon: "heartbeat",
    resourceLabel: "คลาส / เครื่องออกกำลังกาย",
    staffLabel: "เทรนเนอร์",
    modules: ["crm", "booking", "resource", "catalog", "course", "membership", "billing", "installment", "campaign", "fleet"],
  },
  {
    key: "spa",
    name: "สปา & นวดเพื่อสุขภาพ",
    nameEn: "Spa & Massage",
    icon: "moon",
    resourceLabel: "ห้องนวด",
    staffLabel: "พนักงานนวด",
    modules: ["crm", "booking", "resource", "catalog", "course", "membership", "billing", "pos", "chat", "commission"],
  },
  {
    key: "salon",
    name: "ร้านเสริมสวย / บาร์เบอร์",
    nameEn: "Salon & Barber",
    icon: "scissors",
    resourceLabel: "เก้าอี้ / เตียงสระ",
    staffLabel: "ช่างผม",
    modules: ["crm", "booking", "resource", "catalog", "membership", "pos", "billing", "commission", "inventory"],
  },
  {
    key: "vehicle_rental",
    name: "เช่ารถมอเตอร์ไซค์ / รถยนต์",
    nameEn: "Vehicle Rental",
    icon: "motorcycle",
    resourceLabel: "รถ",
    staffLabel: "เจ้าหน้าที่",
    modules: ["crm", "booking", "resource", "fleet", "contract", "billing", "installment", "slip", "chat", "campaign"],
  },
  {
    key: "equipment_rental",
    name: "ให้เช่าอุปกรณ์ / เครื่องมือ",
    nameEn: "Equipment Rental",
    icon: "boxes",
    resourceLabel: "อุปกรณ์",
    staffLabel: "เจ้าหน้าที่",
    modules: ["crm", "booking", "resource", "fleet", "contract", "billing", "inventory", "slip"],
  },
  {
    key: "garage",
    name: "อู่ซ่อมรถ / ศูนย์บริการ",
    nameEn: "Auto Garage",
    icon: "wrench",
    resourceLabel: "ช่องซ่อม",
    staffLabel: "ช่าง",
    modules: ["crm", "booking", "resource", "inventory", "catalog", "billing", "field_service", "commission", "chat"],
  },
  {
    key: "realestate",
    name: "อสังหาริมทรัพย์ / นายหน้า",
    nameEn: "Real Estate Agency",
    icon: "building",
    resourceLabel: "ยูนิต / โครงการ",
    staffLabel: "นายหน้า",
    modules: ["crm", "catalog", "contract", "billing", "installment", "commission", "campaign", "chat", "booking"],
  },
  {
    key: "property_rental",
    name: "หอพัก / ห้องเช่า",
    nameEn: "Property Rental",
    icon: "bed",
    resourceLabel: "ห้อง",
    staffLabel: "แม่บ้าน / ช่าง",
    modules: ["crm", "resource", "contract", "billing", "installment", "slip", "field_service", "campaign"],
  },
  {
    key: "social_commerce",
    name: "แม่ค้าออนไลน์ / ไลฟ์สด",
    nameEn: "Social Commerce",
    icon: "mobile",
    resourceLabel: "-",
    staffLabel: "แอดมินเพจ",
    modules: ["crm", "catalog", "oms", "chat", "slip", "inventory", "billing", "campaign", "membership"],
  },
  {
    key: "retail",
    name: "ค้าปลีก / ค้าส่ง + POS",
    nameEn: "Retail & Wholesale",
    icon: "store",
    resourceLabel: "-",
    staffLabel: "พนักงานขาย",
    modules: ["crm", "catalog", "pos", "inventory", "oms", "billing", "membership", "commission", "campaign"],
  },
  {
    key: "education",
    name: "โรงเรียนกวดวิชา / คอร์สออนไลน์",
    nameEn: "Education & Courses",
    icon: "graduation",
    resourceLabel: "ห้องเรียน",
    staffLabel: "ครูผู้สอน",
    modules: ["crm", "booking", "resource", "course", "catalog", "billing", "installment", "campaign", "chat", "membership"],
  },
  {
    key: "lending",
    name: "สินเชื่อ / เช่าซื้อ",
    nameEn: "Lending & Leasing",
    icon: "bank",
    resourceLabel: "-",
    staffLabel: "เจ้าหน้าที่สินเชื่อ",
    modules: ["crm", "contract", "installment", "billing", "slip", "campaign", "commission"],
  },
  {
    key: "restaurant",
    name: "ร้านอาหาร / คาเฟ่",
    nameEn: "Restaurant & Cafe",
    icon: "coffee",
    resourceLabel: "โต๊ะ",
    staffLabel: "พนักงานร้าน",
    modules: ["crm", "booking", "resource", "catalog", "pos", "inventory", "membership", "billing", "campaign"],
  },
  {
    key: "travel",
    name: "ทัวร์ / ท่องเที่ยว",
    nameEn: "Travel & Tour",
    icon: "plane",
    resourceLabel: "รอบเดินทาง",
    staffLabel: "ไกด์ / เซลส์",
    modules: ["crm", "booking", "resource", "catalog", "billing", "installment", "contract", "chat", "commission", "campaign"],
  },
  {
    key: "field_service",
    name: "บริการนอกสถานที่ / ช่างรับเหมา",
    nameEn: "Field Service",
    icon: "truck",
    resourceLabel: "ทีมช่าง",
    staffLabel: "ช่าง",
    modules: ["crm", "booking", "field_service", "catalog", "inventory", "billing", "contract", "commission"],
  },
];

export const BUSINESS_MODEL_MAP = BUSINESS_MODELS.reduce((acc, item) => {
  acc[item.key] = item;
  return acc;
}, {});

export const getBusinessModel = (key) => BUSINESS_MODEL_MAP[key] || BUSINESS_MODELS[0];
